import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const CARDS = [
  {
    src: "https://images.unsplash.com/photo-1637597384611-0c33cef6ec03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxwb3N0Y2FyZHMlMjBzdGFja2VkfGVufDB8fHx8MTc4NDIzMjY3M3ww&ixlib=rb-4.1.0&q=85",
    label: "The Farm Mailer",
    caption: "For agents working a zip code",
    rot: "-rotate-6",
    top: "top-4",
    left: "left-[4%]",
    w: "w-[280px] md:w-[360px]",
  },
  {
    src: "https://images.unsplash.com/photo-1578531504112-0dcd95eda450?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxwb3N0YWwlMjBzdGFtcCUyMG1haWx8ZW58MHx8fHwxNzg0MjMyNjczfDA&ixlib=rb-4.1.0&q=85",
    label: "The Thank-You",
    caption: "For after every purchase",
    rot: "rotate-4",
    top: "top-24",
    left: "left-[34%]",
    w: "w-[240px] md:w-[320px]",
  },
  {
    src: "https://images.unsplash.com/photo-1599498448014-81d90414c50a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxoYW5kd3JpdHRlbiUyMG5vdGUlMjBwYXBlcnxlbnwwfHx8fDE3ODQyMzI2NzN8MA&ixlib=rb-4.1.0&q=85",
    label: "The Handwritten",
    caption: "For prospects worth 5 minutes",
    rot: "-rotate-3",
    top: "top-8",
    left: "left-[60%]",
    w: "w-[260px] md:w-[340px]",
  },
  {
    src: "https://images.unsplash.com/photo-1584382179644-9c11f8e6ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxwb3N0YWwlMjBzdGFtcCUyMG1haWx8ZW58MHx8fHwxNzg0MjMyNjczfDA&ixlib=rb-4.1.0&q=85",
    label: "The Reactivator",
    caption: "For lists gone cold",
    rot: "rotate-6",
    top: "top-40",
    left: "left-[80%]",
    w: "w-[220px] md:w-[300px]",
  },
];

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const y1 = useTransform(scrollYProgress, [0, 1], [80, -120]);
  const y2 = useTransform(scrollYProgress, [0, 1], [40, -180]);
  const y3 = useTransform(scrollYProgress, [0, 1], [100, -80]);
  const y4 = useTransform(scrollYProgress, [0, 1], [140, -60]);

  const ys = [y1, y2, y3, y4];

  return (
    <section
      id="gallery"
      ref={ref}
      className="relative bg-[#EAE5DC] overflow-hidden py-24 md:py-36 border-y border-[#D5D0C5]"
      data-testid="gallery-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="postmark text-[#2B3A55] mb-6">
              <span className="w-1 h-1 rounded-full bg-[#2B3A55]" />
              The Cards
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] tracking-tight text-[#1C1C1A] max-w-3xl">
              Four templates that print money{" "}
              <span className="italic text-[#D93829]">— literally on paper</span>.
            </h2>
          </div>
          <p className="max-w-sm text-[#3B3A36] text-lg font-sans-body">
            Every card is a 4×6 canvas of first-class mail — your logo, your
            voice, your offer. Pick a starter and edit the wording in under two
            minutes.
          </p>
        </div>
      </div>

      {/* Scattered layered postcards */}
      <div className="relative h-[560px] md:h-[640px] max-w-[1440px] mx-auto">
        {CARDS.map((c, i) => (
          <motion.div
            key={c.label}
            style={{ y: ys[i] }}
            whileHover={{ scale: 1.03, rotate: 0, zIndex: 50 }}
            transition={{ type: "spring", stiffness: 180, damping: 20 }}
            className={`absolute ${c.top} ${c.left} ${c.w} ${c.rot} polaroid cursor-pointer`}
            data-testid={`gallery-card-${i}`}
          >
            <img
              src={c.src}
              alt={c.label}
              className="w-full h-[220px] md:h-[280px] object-cover"
            />
            <div className="mt-3 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-[#68655E]">
              <span>{c.label}</span>
              <span className="font-hand text-[15px] text-[#D93829] normal-case tracking-normal">
                {c.caption}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
